/* ==========================================================================
   ATHLO+ — partner phone gate (2026-10-06). Removable: delete this file and
   its <script> lines in snippets/hub-cart-drawer.liquid and
   sections/main-cart.liquid, and the data-hub-phone-gate branch there.
   --------------------------------------------------------------------------
   WHY. A service partner arranges the session or package with the customer
   themselves and needs a phone number, not just the order email - the owner:
   "chances of them reading their emails are significantly lower", then "all
   services ... it makes it easier for all the partners". STR asked first.
   Both places a service enters the bag REQUIRE the number: the product page
   (`properties[Phone]`, sections/main-product.liquid, every Services product)
   and the booking picker (`_booking_whatsapp`, hub-booking require_phone /
   require_whatsapp), so a bag made on athlo.sg always has it.
   This catches every OTHER way a line can reach the bag without one - a bag
   from before the field existed, a restored cart, a re-order - at the last
   point the theme controls: the click on Checkout. The store is on Basic, so
   Shopify's checkout itself cannot be made to ask (that needs Plus).
   What the theme cannot see (a typed /checkout URL, a cart permalink, the
   Shop app) is caught after payment by the backend, which raises
   exception.partner_sale_no_phone so ops can get the number.
   --------------------------------------------------------------------------
   HOW. A capture-phase click listener on every checkout control. It reads
   /cart.js; if a SERVICE line (product type Services, or a booked session -
   it carries _booking_hold_id) has neither number it opens a prompt, writes
   the number onto each such line as Phone (/cart/change.js with the line's
   own properties, hold id and token included, plus Phone), then lets the
   original click through. jobs.ts reads Phone on both the pass and the
   booking path.
   A failed /cart.js read lets checkout proceed: blocking a sale on a network
   blip would cost more than the backend net it falls back to.
   The property name and the field pattern MUST match main-product.liquid and
   jobs.ts PASS_PHONE_PROP - _verify/partner-pass-terms-test.ts pins all three.
   ========================================================================== */
(function () {
  'use strict';
  // Loaded by BOTH the drawer snippet and the cart page (the drawer can be switched off), so the
  // second copy must not add a second listener - that would prompt twice.
  if (window.__hubPhoneGate) return;
  window.__hubPhoneGate = true;
  var PROP = 'Phone';
  var BOOKING_PHONE = '_booking_whatsapp';     // hub-booking.js LI_X.WHATSAPP
  var HOLD = '_booking_hold_id';               // hub-booking.js LI.HOLD_ID
  var PATTERN = /^\+?[0-9 ]{8,19}$/;
  var CHECKOUT = 'a[href="/checkout"], a[href^="/checkout?"], button[name="checkout"], input[name="checkout"], [data-hub-phone-gate]';

  // A service line: sold as a Services product, or a booked session. Gift cards and gear never are.
  function isService(it) {
    var t = String(it.product_type || '').toLowerCase().trim();
    return t === 'services' || t === 'service' || !!String((it.properties || {})[HOLD] || '').trim();
  }
  // Has a number if either property holds 7+ digits - the same test as jobs.ts phoneish().
  function hasPhone(it) {
    var p = it.properties || {};
    return String(p[PROP] || p[BOOKING_PHONE] || '').replace(/[^0-9]/g, '').length >= 7;
  }
  function needsPhone(it) { return isService(it) && !hasPhone(it); }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // Writes the number onto EVERY line that still lacks it. One line per round trip, re-reading the
  // cart each time, because a property change gives the line a new key.
  function writePhone(phone) {
    var rounds = 0;
    function step() {
      return getCart().then(function (cart) {
        var it = (cart.items || []).filter(needsPhone)[0];
        if (!it) return cart;
        if (++rounds > 20) throw new Error('too many lines');
        var props = {};
        Object.keys(it.properties || {}).forEach(function (k) { props[k] = it.properties[k]; });
        props[PROP] = phone;
        return fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props })
        }).then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return step(); });
      });
    }
    return step();
  }

  function css() {
    if (document.getElementById('hub-phone-gate-css')) return;
    var s = document.createElement('style');
    s.id = 'hub-phone-gate-css';
    s.textContent =
      // margin/inset/height restate the browser's own centring for a modal dialog: the theme's reset
      // zeroes every margin, which pinned this to the top-left corner (seen live 2026-10-06).
      '.hub-phone-gate{position:fixed;inset:0;margin:auto;height:fit-content;max-height:calc(100vh - 2rem);overflow:auto;border:1px solid var(--line,#2A323C);border-radius:16px;background:var(--ink-800,#0b0e12);color:var(--fg,#EFEFEF);padding:1.4rem 1.4rem 1.2rem;max-width:min(420px,calc(100vw - 2rem));width:100%;box-sizing:border-box}' +
      '.hub-phone-gate::backdrop{background:rgba(0,0,0,.6)}' +
      '.hub-phone-gate h2{margin:0 0 .5rem;font-size:1.05rem;line-height:1.3}' +
      '.hub-phone-gate p{margin:0 0 .9rem;font-size:.9rem;line-height:1.5;color:var(--muted,#9aa4b2)}' +
      '.hub-phone-gate ul{margin:0 0 .9rem;padding-left:1.1rem;font-size:.88rem;line-height:1.5;list-style:disc}' +
      '.hub-phone-gate label{display:block;font-family:var(--font-mono,monospace);font-size:.72rem;letter-spacing:.14em;text-transform:uppercase;color:var(--muted,#9aa4b2);margin-bottom:.45rem}' +
      '.hub-phone-gate input{width:100%;min-height:44px;padding:.8em 1.1em;border:1px solid var(--line,#2A323C);border-radius:100px;background:var(--ink-700,#161B22);color:var(--fg,#EFEFEF);font:inherit}' +
      '.hub-phone-gate input:focus-visible{outline:2px solid var(--lime,#B7FF00);outline-offset:2px}' +
      '.hub-phone-gate__err{min-height:1.2em;margin:.45rem 0 0;font-size:.82rem;color:#ff8a8a}' +
      '.hub-phone-gate__row{display:flex;gap:.6rem;justify-content:flex-end;margin-top:1rem;flex-wrap:wrap}';
    document.head.appendChild(s);
  }

  // "STR Fitness Club", or "FORGED BY ReFormd and STR Fitness Club" for a bag from two partners.
  function who(lines) {
    var names = [];
    lines.forEach(function (it) { var v = String(it.vendor || '').trim(); if (v && names.indexOf(v) < 0) names.push(v); });
    if (!names.length) return 'Our partners';
    return names.length === 1 ? names[0] : names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
  }

  function prompt(lines) {
    return new Promise(function (resolve) {
      css();
      var d = document.createElement('dialog');
      d.className = 'hub-phone-gate';
      d.setAttribute('aria-labelledby', 'hub-phone-gate-t');
      d.innerHTML =
        '<form method="dialog" novalidate>' +
          '<h2 id="hub-phone-gate-t">One more thing before checkout</h2>' +
          '<p>' + esc(who(lines)) + ' arrange this with you directly, so they need a number to reach you on, as well as your email.</p>' +
          '<ul>' + lines.map(function (it) {
            return '<li>' + esc(it.product_title) + (it.variant_title && it.variant_title !== 'Default Title' ? ' &ndash; ' + esc(it.variant_title) : '') + '</li>';
          }).join('') + '</ul>' +
          '<label for="hub-phone-gate-in">Mobile number</label>' +
          '<input id="hub-phone-gate-in" type="tel" inputmode="tel" autocomplete="tel" maxlength="20" placeholder="e.g. 9123 4567" required>' +
          '<p class="hub-phone-gate__err" aria-live="polite"></p>' +
          '<div class="hub-phone-gate__row">' +
            '<button type="button" class="btn btn--ghost" data-hpg-cancel><span>Back to bag</span></button>' +
            '<button type="submit" class="btn btn--blue" data-hpg-save><span>Save and check out</span></button>' +
          '</div>' +
        '</form>';
      document.body.appendChild(d);
      var input = d.querySelector('input'), err = d.querySelector('.hub-phone-gate__err'), save = d.querySelector('[data-hpg-save]');
      function done(v) { try { d.close(); } catch (e) {} d.remove(); resolve(v); }
      d.querySelector('[data-hpg-cancel]').addEventListener('click', function () { done(null); });
      d.addEventListener('cancel', function (e) { e.preventDefault(); done(null); });
      d.querySelector('form').addEventListener('submit', function (e) {
        e.preventDefault();
        var v = input.value.trim().replace(/\s{2,}/g, ' ');
        if (!PATTERN.test(v)) { err.textContent = 'Digits only, e.g. 9123 4567 or +65 9123 4567.'; input.focus(); return; }
        err.textContent = ''; save.disabled = true;
        writePhone(v).then(function () { done(v); }).catch(function () {
          save.disabled = false;
          err.textContent = 'That didn’t save — please try again.';
        });
      });
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      setTimeout(function () { input.focus(); }, 30);
    });
  }

  function proceed(el) {
    // The cart page's gated button is a plain button (main-cart.liquid renders it that way when a
    // line is missing its number, so it does nothing without this script). Submit its form AS a
    // checkout, keeping any quantity edits the shopper made.
    if (el.hasAttribute('data-hub-phone-gate')) {
      var form = el.closest('form');
      if (form) {
        var h = document.createElement('input');
        h.type = 'hidden'; h.name = 'checkout'; h.value = '1';
        form.appendChild(h); form.submit(); return;
      }
      window.location.href = '/checkout'; return;
    }
    el.__hubPhoneOk = true;
    el.click();
    setTimeout(function () { el.__hubPhoneOk = false; }, 0);
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest(CHECKOUT) : null;
    if (!el || el.__hubPhoneOk) return;
    e.preventDefault();
    e.stopPropagation();
    getCart().then(function (cart) {
      var missing = (cart.items || []).filter(needsPhone);
      if (!missing.length) return proceed(el);
      return prompt(missing).then(function (v) { if (v) proceed(el); });
    }).catch(function () { proceed(el); });
  }, true);
})();
